export default __webpack_public_path__ + "static/media/le_touquet17.7f4e7804.jpg";